export default "__VITE_ASSET__Bx$9LeB0__"